module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.8@readable-stream/transform.js
// module id = 771
// module chunks = 0